import React, { Component } from 'react';
import './ec2Explorer.css';
import Ec2ExTitle from './ec2ExTitle/ec2ExTitle.js';
import Ec2ExMain from './ec2ExMain/ec2ExMain.js';
import Ec2ExSidebar from './ec2ExSidebar/ec2ExSidebar.js';
import StatusOverlay from '../../universal/statusOverlay/statusOverlay.js';
import getAllInstances from './utils/getAllInstances.js';
import {Auth} from 'aws-amplify';
import tableHeaders from './utils/tableHeaders.js';

class Ec2Explorer extends Component {

  state = {
    instances: [],
    headers: [...tableHeaders],
    loadingStatus: 'Loading...',
    filter: [
      {
        id: 'filter0',
        header: 'hidden',
        operator: 'Equals',
        filterVal: 'False'
      }
    ]
  }

  componentDidMount() {

    setTimeout(() => {
      Auth.currentCredentials()
      .then(credentials => {
        return getAllInstances(Auth.essentialCredentials(credentials));
      })
      .then(instances => {
        const headers = [...this.state.headers];
        instances.forEach(instance => {
          instance.Tags.forEach(tag => {
            if (!headers.find(header => header.title === `Tags - ${tag.Key}`)) {
              headers.push({
                title: `Tags - ${tag.Key}`,
                key: `tags-${tag.Key}`,
                find: ['Tags', 'Key', tag.Key],
                hidden: false
              });
            }
          });
        });
        instances.map(instance => {
          headers.filter(header => /tags-/.test(header.key)).forEach(header => {
            instance[header.key] = instance.Tags.find(tag => tag.Key === header.key.slice(5)) ? instance.Tags.find(tag => tag.Key === header.key.slice(5)).Value : 'No Tag Found';
          });
          return instance;
        });
        this.setState({
          instances,
          headers,
          loadingStatus: ''
        });
      })
      .catch(err => {
        console.log(err);
      });
    }, 0);

  }

  render() {

    return (
      <div className="Ec2ExplorerPage">
        <Ec2ExTitle
          headers={this.state.headers}
          addFilter={this.addFilter}
          filter={this.state.filter}
          removeFilter={this.removeFilter}
          invertFilter={this.invertFilter}
          downloadCsv={this.downloadCsv}
        />
        <Ec2ExMain
          instances={this.state.instances.filter(this.instanceFilter)}
          headers={this.state.headers.filter(header => !header.hidden)}
          toggleColumnVisibility={this.toggleColumnVisibility}
          swapColumnOrder={this.swapColumnOrder}
          sortColumn={this.sortColumn}
          toggleHideRow={this.toggleHideRow}
          swapInstanceOrder={this.swapInstanceOrder}
        />
        <Ec2ExSidebar
          instances={this.state.instances}
          headers={this.state.headers}
          toggleColumnVisibility={this.toggleColumnVisibility}
        />
        <StatusOverlay
          loadingStatus={this.state.loadingStatus}
        />
      </div>
    );

  }

  downloadCsv = () => {

    if (this.state.instances.length === 0) window.alert('No data to download. Please wait for the instance data to finish fetching.');
    else {
      let csvData = 'data:text/csv;charset=utf-8,';
      const visHeaders = this.state.headers.slice(1).filter(header => !header.hidden);
      csvData += visHeaders.map(header => header.title).join(',') + '\r\n';
      this.state.instances.filter(this.instanceFilter).forEach((instance, index) => {
        let row = visHeaders.map(header => instance[header.key]);
        row = row.map(cell => {
          if (cell === undefined) return 'undefined';
          else if (typeof cell === 'string') return cell;
          else if (typeof cell === 'object') return JSON.stringify(cell);
          else return cell.toString();
        });
        row = row.map(cell => {
          return `${cell.replace(/"/g, '""').replace(/#/g, '-hash-')}`;
        });
        // console.log(row);
        csvData += '"' + row.join('","') + '"\r\n';
        // console.log(instance)
      });
      const encodedUri = encodeURI(csvData);
      const link = document.createElement('a');
      link.setAttribute('href', encodedUri);
      link.setAttribute('id', 'csvDownloadLink');
      link.setAttribute('download', 'ec2ReservationExplorerOutput.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

  }

  toggleColumnVisibility = title => {

    const newHeaders = [...this.state.headers];
    const headerToChange = newHeaders.find(header => header.title === title);
    headerToChange.hidden = !headerToChange.hidden;
    this.setState({headers: newHeaders}, () => this.setState({loading: false}));

  }

  swapColumnOrder = (title, dir) => {
    const newHeaders = [...this.state.headers];
    const fromIndex = newHeaders.findIndex(header => header.title === title);
    let foundSwap = false;
    let toIndex = fromIndex;
    while (!foundSwap) {
      toIndex = toIndex + dir;
      if (toIndex < 1 || toIndex >= newHeaders.length) {
        return;
      } else {
        foundSwap = !newHeaders[toIndex].hidden;
      }
    }
    newHeaders[fromIndex] = this.state.headers[toIndex];
    newHeaders[toIndex] = this.state.headers[fromIndex];
    this.setState({headers: newHeaders}, () => console.timeEnd('swapColumnOrder'));
  }

  sortColumn = (title, dir) => {
    const sortHeader = this.state.headers.find(header => header.title === title);
    const sortedInstances = [...this.state.instances];
    sortedInstances.sort((a ,b) => {
      a = a[sortHeader.key];
      b = b[sortHeader.key];
      if (typeof a === 'number' && typeof b === 'number') {
        return (a - b) * dir * -1;
      } else {
        if (a === undefined) a = '0';
        if (b === undefined) b = '0';
        console.log(JSON.stringify(a), JSON.stringify(b));
        if ([JSON.stringify(a).toUpperCase(), JSON.stringify(b).toUpperCase()].sort()[0] === JSON.stringify(a).toUpperCase()) return dir;
        else return dir * -1;
      }
    });
    this.setState({instances: sortedInstances});
  }

  toggleHideRow = instanceId => {
    const newInstances = [...this.state.instances];
    const fromIndex = newInstances.findIndex(instance => instance.InstanceId === instanceId);
    newInstances[fromIndex].hidden = newInstances[fromIndex].hidden === 'True' ? 'False' : 'True';
    this.setState({instances: newInstances});
  }

  swapInstanceOrder = (instanceId, dir) => {
    const newInstances = [...this.state.instances];
    const fromIndex = newInstances.findIndex(instance => instance.InstanceId === instanceId);
    let foundSwap = false;
    let toIndex = fromIndex;
    while (!foundSwap) {
      toIndex = toIndex + dir;
      if (toIndex < 0 || toIndex >= newInstances.length) {
        return;
      } else {
        foundSwap = this.instanceFilter(newInstances[toIndex]);
      }
    }
    newInstances[fromIndex] = this.state.instances[toIndex];
    newInstances[toIndex] = this.state.instances[fromIndex];
    this.setState({instances: newInstances});
  }

  addFilter = filter => {
    this.setState({filter: [...this.state.filter, filter]});
  }

  instanceFilter = instance => {

    const {filter} = this.state;
    let toBeReturned = true;

    filter.forEach(filter => {

      const key = filter.header;
      const opp = filter.operator;
      const val = filter.filterVal;
      const instanceVal = instance[key];
      const valRegExp = new RegExp(val);

      if (opp === 'Equals') {
        toBeReturned = toBeReturned && instanceVal === val;
      } else if (opp === 'Doesn\'t Equal') {
        toBeReturned = toBeReturned && instanceVal !== val;
      } else if (opp === 'Contains') {
        toBeReturned = toBeReturned && valRegExp.test(instanceVal);
      } else if (opp === 'Doesn\'t Contain') {
        toBeReturned = toBeReturned && !valRegExp.test(instanceVal);
      }

    });

    return toBeReturned;
  }

  removeFilter = index => {
    const newFilter = this.state.filter;
    newFilter.splice(index, 1);
    this.setState({filter: newFilter});
  }

  invertFilter = index => {
    const newFilter = this.state.filter;
    if (newFilter[index].operator === 'Equals') newFilter[index].operator = 'Doesn\'t Equal';
    else if (newFilter[index].operator === 'Doesn\'t Equal') newFilter[index].operator = 'Equals';
    else if (newFilter[index].operator === 'Contains') newFilter[index].operator = 'Doesn\'t Contain';
    else if (newFilter[index].operator === 'Doesn\'t Contain') newFilter[index].operator = 'Contains';
    this.setState({filter: newFilter});
  }

}

export default Ec2Explorer;


// WEBPACK FOOTER //
// ./src/components/content/ec2ResExplorer/ec2ResExplorer.js